export const MONETIZATION_STATUS_PENDING = 1;

export const isAvalAnnulable = (monetizationStatusTypeId?: number | null): boolean =>
  monetizationStatusTypeId === MONETIZATION_STATUS_PENDING;

export const resolveAnnulInstrumentType = (guaranteeType?: string | null): string => {
  const normalized = guaranteeType?.trim().toLowerCase().replace(/-/g, '_');
  if (normalized === 'loan') return 'loan';
  if (normalized === 'check') return 'check';
  if (normalized === 'promissory_note') return 'promissory-note';
  if (normalized === 'commercial_endorsement') return 'commercial-endorsement';
  return 'check';
};
